import { Component } from 'react';

export class DocumentSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;
        return (
            <svg
                className={className}
                width="23"
                height="29"
                viewBox="0 0 23 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.0829 0.27594L22.7915 6.65485C22.9255 6.80481 23 6.99841 23 7.19922V28.1797C23 28.6328 22.6296 29 22.1726 29H0.827393C0.370361 29 0 28.6328 0 28.1797V0.820312C0 0.367188 0.370361 0 0.827393 0H16.464C16.7007 0 16.9257 0.100403 17.0829 0.27594ZM20.3691 6.41962L17.2778 2.9657V6.41962H20.3691ZM21.3451 27.3595H1.65442V1.64081H15.6229V7.24005C15.6229 7.69324 15.9932 8.06036 16.4502 8.06036H21.3451V27.3595ZM5.4458 14.8008C4.98877 14.8008 4.61841 14.4336 4.61841 13.9804C4.61841 13.5273 4.98877 13.1601 5.4458 13.1601H17.5547C18.0117 13.1601 18.382 13.5273 18.382 13.9804C18.382 14.4336 18.0117 14.8008 17.5547 14.8008H5.4458ZM17.5547 17.594H5.4458C4.98877 17.594 4.61841 17.9612 4.61841 18.4143C4.61841 18.8674 4.98877 19.2346 5.4458 19.2346H17.5547C18.0117 19.2346 18.382 18.8674 18.382 18.4143C18.382 17.9612 18.0117 17.594 17.5547 17.594ZM5.4458 22.027H17.5547C18.0117 22.027 18.382 22.3942 18.382 22.8473C18.382 23.3004 18.0117 23.6676 17.5547 23.6676H5.4458C4.98877 23.6676 4.61841 23.3004 4.61841 22.8473C4.61841 22.3942 4.98877 22.027 5.4458 22.027Z"
                    fill="#0C2340"
                />
            </svg>
        );
    }
}
